import { createValidator } from 'hooks/useFormData/validation';

const glossaryValidator = {
  pageTitle: createValidator([{ type: 'required' }, { type: 'maxLength', value: 60, message: 'The "Page title" is too long (maximum is 60 characters)' }]),
  title: createValidator([{ type: 'required' }, { type: 'maxLength', value: 60, message: 'The "Title" is too long (maximum is 60 characters)' }]),
  description: createValidator([{ type: 'required' }]),
};

export default glossaryValidator;
